export const KAHVE_MECNUN = [
  {
    id: "kmec001",
    metin: "{{ad}}, kırk ülkede kahve fincanı okudum. Bu fincan bana Doğu'nun bilgeliğini hatırlatıyor. {{soru}} konusunda şunu söyleyeyim: evren rastlantı tanımaz. Şu an yaşadığın her şey, seni belirli bir noktaya taşımak için tasarlanmış.\n\nO noktanın ne olduğunu henüz göremiyorsun — ama fincan görüyor. Büyük bir dönüşümün eşiğindesin. Bu dönüşüme direnmek yerine rehberlik et ona.",
    tema: "donusum"
  },
  {
    id: "kmec002",
    metin: "{{ad}}, fincanını elimde tutarken Hint astrolojisinin yedi gezegen teorisini düşündüm. {{soru}} konusunda şu an Satürn etkisi altındasın — sabır, disiplin, yavaş ama kalıcı ilerleme.\n\nBu dönem seni zorlayacak ama pişirecek. Altın ateşte arınır. Ve bu ateş geçici — ama seni kalıcı olarak güçlendirecek.",
    tema: "sabir"
  },
  {
    id: "kmec003",
    metin: "{{ad}}, kırk yıllık tecrübemle şunu söyleyebilirim: bu fincan nadir görülen bir şekil taşıyor. {{soru}} için evrenin sana özel bir plan yaptığını hissediyorum.\n\nJaponya'da bir bilge demişti ki: 'En karanlık gece, şafaktan hemen öncedir.' Sabah yakın. O sabahlık için biraz daha sabret.",
    tema: "umut"
  },
  {
    id: "kmec004",
    metin: "{{ad}}, fincanın bana Çin felsefesinin yin-yang prensibini hatırlattı. {{soru}} konusunda şu an dengesizlik var — ya çok fazla yin ya da çok fazla yang.\n\nBu dengeyi bulmak için içe bakman gerekiyor. Dışarıda aradığını içeride bulacaksın. Meditasyon mu, sessiz bir yürüyüş mü, yalnız bir an mı — ne olursa olsun, kendinle baş başa kal.",
    tema: "denge"
  },
  {
    id: "kmec005",
    metin: "{{ad}}, bu fincanı görünce Mısır'daki bir fal ustamı hatırladım. O derdi ki: 'Kahve yalan söylemez, insan yorumlamakta yanılır.' {{soru}} konusunda fincan çok net — yakında maddi bir rahatlama var.\n\nAma bu rahatlama beklenmedik bir kanaldan gelecek. Gözünü aç, her kapıyı değerlendir. Bereket bazen tanımadığımız kapılardan girer.",
    tema: "para"
  },
  {
    id: "kmec006",
    metin: "{{ad}}, fincanının geometrisine bak. {{soru}} konusunda hayatın da şu an böyle geometrik bir düzen içinde — her şey yerli yerinde oturuyor, sen sadece tamamını göremiyorsun.\n\nUzaktan baksaydın, o mükemmel deseni görürdün. Bir adım geri çekil, perspektifi genişlet. Büyük resmi görmek için bazen yakından uzaklaşmak gerekir.",
    tema: "desen"
  },
  {
    id: "kmec007",
    metin: "{{ad}}, Brezilya'da öğrendiğim bir şey var: kahve fincanı kişinin aura rengiyle konuşur. {{soru}} için fincanın bana mor bir enerji gösteriyor — sezgi ve ruhsallık demek.\n\nŞu an sezgilerin çok güçlü. Onlara kulak ver, mantığını bir kenara bırak. Mor enerji nadiren yanılır — ve şu an senin içinde çok aktif.",
    tema: "sezgi"
  },
  {
    id: "kmec008",
    metin: "{{ad}}, fincanında ilginç bir şekil var — bir sarmal. Evrenin en temel formu. {{soru}} konusunda da hayatın spiral bir şekilde ilerlediğini unutma.\n\nAynı noktaya döndüğünü sanıyorsun ama aslında yukarı çıkıyorsun — sadece dönüyor gibi görünüyor. Her tur, bir öncekinden daha yukarıda.",
    tema: "ilerleme"
  },
  {
    id: "kmec009",
    metin: "{{ad}}, Marakeş'te bir bilge şöyle demişti: 'Fincan geçmişi gösterir, falcı geleceği yorumlar.' {{soru}} için geçmişine bak — orada bir ipucu var.\n\nTekrar eden bir kalıp, tekrar eden bir hata ya da tekrar eden bir fırsat. Gör onu. Geçmiş bir öğretmendir — ders çıkarılırsa anlamlıdır.",
    tema: "gecmis"
  },
  {
    id: "kmec010",
    metin: "{{ad}}, fincanın bana ateş elementi gösteriyor. {{soru}} konusunda tutku ve güç var içinde — ama kontrol edilmemiş ateş yakar.\n\nBu enerjiyi doğru kanalize et. Hedef belirle, odaklan, sonra o ateşi yak. Odaklanmış ateş pişirir, dağınık ateş yakar — fark bu.",
    tema: "ates"
  },
  {
    id: "kmec011",
    metin: "{{ad}}, kırk ülkede gördüğüm en ilginç fincanlardan biri bu. {{soru}} konusunda şunu söyleyeyim: sen sıradan bir insan değilsin. Fincan bunu açıkça gösteriyor.\n\nSıradanlığa razı olma — büyük şeyler için doğdun. Bu kibir değil, gerçek. Fincanlar yalan söylemez.",
    tema: "potansiyel"
  },
  {
    id: "kmec012",
    metin: "{{ad}}, Uzak Doğu felsefesinde 'wu wei' denir — zorlamasız eylem. {{soru}} konusunda çok zorluyor olabilirsin.\n\nBazen en güçlü hareket, hareketsiz kalmaktır. Suya bak — en sert kayaları bile aşındırır, ama zorlamaz. Sen de zorlamayı bırak — doğru zamanda, doğru yönde akar.",
    tema: "akis"
  },
  {
    id: "kmec013",
    metin: "{{ad}}, fincanın bana bir üçgen gösteriyor — en stabil geometrik şekil. {{soru}} için hayatında üç sütun lazım: sağlık, ilişki, iş.\n\nBu üçünden biri sarsılırsa denge bozulur. Hangisi zayıf? Onu güçlendir. Üçgen ancak üç köşe de sağlamsa durur.",
    tema: "denge"
  },
  {
    id: "kmec014",
    metin: "{{ad}}, Tibet'te bir lama şöyle demişti: 'Her insan iki hayat yaşar — birincisi gerçek hayatı öğrenene kadar.' {{soru}} konusunda sen gerçek hayatını öğrenme sürecinin ortasındasın.\n\nBu süreç acıtır ama aydınlatır. Ve bir gün geriye dönüp bakacak, 'o dönem beni yaptı' diyeceksin.",
    tema: "ogrenme"
  },
  {
    id: "kmec015",
    metin: "{{ad}}, fincanında su ve toprak enerjisi bir arada. {{soru}} için bu çok güçlü bir kombinasyon — duygu ve pratiklik, hayal ve gerçek.\n\nİkisini dengele: hayallerini pratik adımlarla inşa et. Hayal olmadan yön olmaz, pratik olmadan hareket olmaz. İkisi birlikte seni hedefe taşır.",
    tema: "pratiklik"
  },
  {
    id: "kmec016",
    metin: "{{ad}}, fincan bana bir yolculuk gösteriyor — içsel bir yolculuk. {{soru}} konusunda dışarıda aradığın cevap, aslında içinde.\n\nKendinle baş başa kal. Meditasyon mu, yalnız bir yürüyüş mü, sessiz bir an mı — ne olursa olsun, o iç sesi duy. Dışarıdaki gürültü susunca, içerideki cevap konuşur.",
    tema: "ic_yolculuk"
  },
  {
    id: "kmec017",
    metin: "{{ad}}, Peru'da bir şaman şöyle demişti: 'Korku kapıyı kapatır, cesaret açar.' {{soru}} konusunda bir kapı önünde duruyorsun.\n\nKorkun mu var? Normal. Ama o kapıyı açmak için tam da bu anı bekliyordun. Cesaret korkunun yokluğu değil — korkuya rağmen adım atmaktır.",
    tema: "cesaret"
  },
  {
    id: "kmec018",
    metin: "{{ad}}, fincanının kenarı bana bir mesaj veriyor — bağlantı. {{soru}} konusunda doğru insanlarla bağlantı kurma vakti.\n\nAğını genişlet, yeni kapılar çal. Bir tanıdık, bir bağlantı, bir söz — her şeyi değiştirebilir. İnsanlar arasındaki köprüler, en değerli köprülerdir.",
    tema: "baglanti"
  },
  {
    id: "kmec019",
    metin: "{{ad}}, fincanında altın rengi bir parıltı var — nadiren görürüm bunu. {{soru}} için şunu söyleyeyim: bu fincan şans ve bereket taşıyor.\n\nAma şans hazırlıklı olanı bulur. Hazırlan. Kapı açıldığında içeri girebilecek misin? O soruya şimdiden cevap ver.",
    tema: "sans"
  },
  {
    id: "kmec020",
    metin: "{{ad}}, Yunanistan'da bir fal ustası şöyle demişti: 'Fincan ayna gibidir — falcı değil, kişinin kendisini yansıtır.' {{soru}} konusunda fincan sana şunu yansıtıyor: içindeki o ses, o his, o sezgi — doğru.\n\nGüven. Dışarıdan onay bekleme. En güvenilir pusula içindedir — ve seninki doğru yönü gösteriyor.",
    tema: "guven"
  },
  {
    id: "kmec021",
    metin: "{{ad}}, fincanın bana bir dönem sonu gösteriyor. {{soru}} konusunda bir kapı kapanıyor — ama bu üzücü değil, gerekli.\n\nKapanmayan kapılar yeni kapıların açılmasını engeller. Gönülden uğurla geçeni. Her son, bir sonraki başlangıcın tohumunu taşır.",
    tema: "bitis"
  },
  {
    id: "kmec022",
    metin: "{{ad}}, Arjantin'de öğrendiğim bir şey: kahvenin yoğunluğu, kişinin enerjisini yansıtır. Fincanın yoğun — bu güçlü bir enerji demek. {{soru}} konusunda bu enerjiyi doğru yönet.\n\nGüç yanlış yönde kullanılırsa tükenir. Önce yönünü belirle, sonra o gücü oraya akıt. Yön olmadan güç, rüzgar gibidir — her yere gider, hiçbir yere ulaşmaz.",
    tema: "enerji"
  },
  {
    id: "kmec023",
    metin: "{{ad}}, fincanında bir köprü şekli var. {{soru}} için iki dünya arasında bir köprü kuruyorsun — eski ve yeni, geçmiş ve gelecek.\n\nBu köprüyü sağlam inşa et. Temeli sağlam olanı fırtına yıkmaz. Ve o köprü tamamlandığında, iki yakası da sana minnettar olacak.",
    tema: "kopru"
  },
  {
    id: "kmec024",
    metin: "{{ad}}, kırk yılda öğrendim: en derin bilgelik basit sorularda saklıdır. {{soru}} konusunda şunu sor kendine: 'Bu benim için mi, yoksa başkası için mi?'\n\nCevap her şeyi değiştirir. Başkası için yapılan şeyler enerji tüketir, kendin için yapılanlar enerji verir. Hangisi bu?",
    tema: "soru"
  },
  {
    id: "kmec025",
    metin: "{{ad}}, sunu söyleyeyim: bu fincan kırk ülkede gördüklerimin en güçlülerinden biri. {{soru}} konusunda evren seninle ilgileniyor — bu bir tesadüf değil.\n\nBüyük resmi gör, küçük detaylara takılma. Yolun açık, adımlar emin olsun. Ve şunu bil: bu fincanı okuyan kişi seninle ilgilenmeye devam edecek — evren de.",
    tema: "buyuk_resim"
  }
];